import BaseApiClient from "./base-client";
class ActivitiesApi extends BaseApiClient {
    STUDIES_API_BASE_PATH = "/api/studies";
    ACTIVITIES_API_BASE_PATH = "/api/activities";
    getStudyActivities = async (studyId, withResponses = true, includeDeletedActivities = false, includeDeletedResponses = false) => {
        return this.get(`${this.STUDIES_API_BASE_PATH}/${studyId}/activities`, {
            params: {
                withResponses,
                includeDeletedActivities,
                includeDeletedResponses
            }
        });
    };
    getSiteActivities = async (withResponses = true, includeDeletedActivities = false, includeDeletedResponses = false) => {
        return this.get(this.ACTIVITIES_API_BASE_PATH, {
            params: {
                withResponses,
                includeDeletedActivities,
                includeDeletedResponses
            }
        });
    };
    static instance = new ActivitiesApi();
}
export default ActivitiesApi.instance;
